var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"atom-structured-text"},[(_vm.value)?_c('section',{ref:"editor"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }